export const ARTICLE_CTA_POSITIONS = ['article_early', 'article_middle', 'article_late', 'article_end'] as const;

export type ArticleCtaPosition = (typeof ARTICLE_CTA_POSITIONS)[number];

export const isArticleCtaPosition = (value: unknown): value is ArticleCtaPosition =>
  typeof value === 'string' && ARTICLE_CTA_POSITIONS.some((position) => position === value);

export const assertArticleCtaPosition = (value: unknown): void => {
  if (value !== undefined && !isArticleCtaPosition(value)) {
    throw new Error(`Unsupported blog CTA ctaPosition: ${String(value)}`);
  }
};
